"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShoninshaName = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 承認者
 */
const ShoninshaName = props => {
  const {
    intl,
    shoninshaNm
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_SHONINSHA
    }),
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, _stringUtil.default.emptyToHyphen(shoninshaNm)));
};
exports.ShoninshaName = ShoninshaName;
var _default = exports.default = (0, _reactIntl.injectIntl)(ShoninshaName);